






















































import Vue, { PropType } from 'vue'
import type { SelectOption } from './UiSelect.types'
import UiIcon from '../UiIcon'
export default Vue.extend({
  name: 'UiSelect',
  components: {
    UiIcon
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [Object, Array, String, Number, Boolean],
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: [String, Boolean],
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array as PropType<SelectOption[]>,
      required: true
    },
    placeholder: {
      type: [String, Boolean],
      default: false
    }
  },
  data () {
    return {
      innerValue: this.value || this.placeholder as string
    }
  },
  computed: {
    listeners (): Record<string, any> {
      return {
        ...this.$listeners,
        input: this.input
      }
    }
  },
  watch: {
    value (newVal): void {
      this.innerValue = newVal
    }

  },
  methods: {
    input (event: any): void {
      this.$emit('input', event.target.value)
    }
  }
})
